import {
    ApplePayPayment,
    BancontactPayment,
    BoletoPayment,
    Cheque,
    CreditCardBack,
    GooglePayPayment,
    IdealPayment,
    OxxoPayment,
    PagofacilPayment,
    PaypalPayment,
    RapipagoPayment,
    Receipt,
    SepaPayment,
    SofortPayment,
    Voucher,
} from '@eventbrite/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { PaymentMethodType } from './enums';
import {
    PaymentMethodMetadata,
    PAYMENT_METHODS_METADATA,
} from './paymentMethodMetadata';

export interface PaymentMethodInfo extends PaymentMethodMetadata {
    userString: string | GenericLazyString | React.ReactElement;
    icon: React.ReactNode;
}

export const PAYMENT_METHODS_INFO = {
    [PaymentMethodType.CREDIT]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.CREDIT],
        userString: gettext('Credit or debit card'),
        icon: <CreditCardBack />,
    },
    [PaymentMethodType.IDEAL]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.IDEAL],
        userString: gettext('iDEAL'),
        icon: <IdealPayment />,
    },
    [PaymentMethodType.MAESTRO_BANCONTACT]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.MAESTRO_BANCONTACT],
        userString: gettext('Bancontact'),
        icon: <BancontactPayment />,
    },
    [PaymentMethodType.SOFORT]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.SOFORT],
        userString: gettext('Sofort'),
        icon: <SofortPayment />,
    },
    [PaymentMethodType.NONCE_BRAINTREE]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.NONCE_BRAINTREE], //defaultusercountry env.countrycode
        userString: gettext('PayPal'),
        icon: <PaypalPayment />,
    },
    [PaymentMethodType.SEPA_DIRECT_DEBIT]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.SEPA_DIRECT_DEBIT],
        userString: gettext('Sepa Direct Debit'),
        icon: <SepaPayment />,
    },
    [PaymentMethodType.CASH]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.CASH],
        userString: gettext('Pay at the door'),
        icon: <Voucher />,
    },
    [PaymentMethodType.INVOICE]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.INVOICE],
        userString: gettext('Pay by invoice'),
        icon: <Receipt />,
    },
    [PaymentMethodType.CHECK]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.CHECK],
        userString: gettext('Pay by check'),
        icon: <Cheque />,
    },
    [PaymentMethodType.FPP_PAYPAL]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.FPP_PAYPAL],
        userString: gettext('PayPal'),
        icon: <PaypalPayment />,
    },
    [PaymentMethodType.BOLETO_BANCARIO]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.BOLETO_BANCARIO],
        userString: gettext('Boleto Bancario'),
        icon: <BoletoPayment />,
    },
    [PaymentMethodType.BARCODE]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.BARCODE],
        userString: gettext('Pay in cash with Rapipago or Pagofacil'),
        icon: <OxxoPayment />,
    },
    [PaymentMethodType.RAPIPAGO]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.RAPIPAGO],
        userString: gettext('Pay in cash with Rapipago'),
        icon: <RapipagoPayment />,
    },
    [PaymentMethodType.PAGOFACIL]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.PAGOFACIL],
        userString: gettext('Pay in cash with Pagofacil'),
        icon: <PagofacilPayment />,
    },
    [PaymentMethodType.OXXO]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.OXXO],
        userString: gettext('Pay in cash with OXXO.'),
        icon: <OxxoPayment />,
    },
    [PaymentMethodType.AUTHNET]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.AUTHNET],
        userString: gettext('Authorize.net'),
        icon: <CreditCardBack />,
    },
    [PaymentMethodType.APPLE_PAY]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.APPLE_PAY],
        userString: gettext('Apple Pay'),
        icon: <ApplePayPayment />,
    },
    [PaymentMethodType.GOOGLE_PAY]: {
        ...PAYMENT_METHODS_METADATA[PaymentMethodType.GOOGLE_PAY],
        userString: gettext('Google Pay'),
        icon: <GooglePayPayment />,
    },
} as const;
